import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { SendRemindersPerformanceReviewProcessDocument } from 'generated/resources/graphql'
import moment from 'moment'

import Modal from 'modules/core/components/Modal'
import Sidepanel from 'modules/core/components/Sidepanel'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { customRelativeTime } from 'modules/one_on_ones/lib/customRelativeTime'

import PendingReviewersDataTable from './PendingReviewersDataTable'

export const SendRemindersPanel: React.FC<{
  reviewId: number
  onClose: () => void
  lastReminder?: string
  canRemind: boolean
}> = ({ reviewId, onClose, lastReminder, canRemind }) => {
  const [sendReminderMutation, { loading: sendingReminders }] = useMutation(
    SendRemindersPerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.remindInBulkPerformanceReviewProcess,
    }
  )
  const [ismodalOpen, setIsModalOpen] = React.useState(false)

  const sendReminder = async () => {
    const response = await sendReminderMutation({
      variables: {
        id: Number(reviewId),
      },
    })

    const result = handleResult(response, () => null)
    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('performance_process.overview.participation.send_reminders.success'),
      })
    }
    onClose?.()
    return result
  }

  return (
    <>
      <Sidepanel
        open
        onClose={() => onClose()}
        width="wideXL"
        title={i18n.t('performance_process.overview.participation.pending_reviewers')}
        footer={
          canRemind && (
            <Button type="primary" onClick={() => setIsModalOpen(true)}>
              {i18n.t('performance_process.overview.participation.send_reminders.title')}
            </Button>
          )
        }
      >
        <Box>
          <PendingReviewersDataTable reviewId={reviewId} />
        </Box>
      </Sidepanel>
      {ismodalOpen && (
        <Modal
          title={i18n.t('performance_process.overview.participation.send_reminders.modal.title')}
          description={
            <Box gap="s8">
              <Text size="300">
                {i18n.t(
                  'performance_process.overview.participation.send_reminders.modal.description'
                )}
              </Text>
              {lastReminder && (
                <Text size="300" weight="semibold">
                  {i18n.t(
                    'performance_process.overview.participation.send_reminders.modal.last_reminder'
                  )}
                  {customRelativeTime(moment(lastReminder))}{' '}
                </Text>
              )}
            </Box>
          }
          illustration={'alert'}
          onClose={() => setIsModalOpen(false)}
          footer={
            <>
              <Button
                type="secondary"
                onClick={() => setIsModalOpen(false)}
                disabled={sendingReminders}
              >
                {i18n.t('common.cancel')}
              </Button>
              <Button onClick={() => sendReminder()} disabled={sendingReminders}>
                {i18n.t('performance_process.overview.participation.send_reminders.modal.send')}
              </Button>
            </>
          }
        ></Modal>
      )}
    </>
  )
}
